import React from "react";
import { DATA_DOT } from "../../../core/theme/searchTheme";
import { useAccount } from "../../../core/hooks/useAccount";
import { canSeeAdtao } from "../../../core/data/account";

// Small dots on a keyword tag = how much data we hold (not how good it is).
// Dot 1: your past scans. Dot 2: Google Ads (not connected yet). Dot 3:
// Benchmarks (not connected yet) - AdTao-derived, so only for an account
// allowed to see AdTao.
export default function DataDots({ level, title }) {
  const showBenchmarks = canSeeAdtao(useAccount());
  return (
    <span className="inline-flex items-center gap-0.5" title={title}>
      <span className={DATA_DOT[level]} />
      <span className={DATA_DOT.placeholder} />
      {showBenchmarks && <span className={DATA_DOT.placeholder} data-testid="benchmarks-dot" />}
    </span>
  );
}
